export const ATR_LOCATION_ID = 'locationId'
export const ATR_IS_LOCKED = 'isLocked'
export const ATR_IS_ENABLED = 'isEnabled'
export const ATR_IS_OUT_OF_BUILDING = 'isOutOfBuilding'
export const ATR_CAN_PRINT = 'canPrint'
export const ATR_ENABLE_EMAIL_SLIP = 'enableEmailSlip'
export const ATR_ENABLE_KEYPAD = 'enableKeyPad'
export const ATR_ENABLE_GPS = 'enableGps'
export const ATR_ENABLE_CAMERA = 'enableCamera'
export const ATR_ACCEPT_KEYBOARD_INPUT = 'acceptKeyboardInput'
export const ATR_ATTENDANCE_TYPE = 'atType'
export const ATR_ATTENDANCE_TYPE_ID = 'atTypeId'
export const ATR_CHECKIN_FLOW = 'checkinFlow'
export const ATR_REQUEST_SEND_REPORT = 'requestSendReport'
export const ATR_MAX_LEASE_LENGTH = 'maxLeaseLength'
export const ATR_LEASE_EXPIRES = 'leaseExpires'
export const ATR_ENABLE_PRESENT_SLIP = 'enablePresentSlip'
export const ATR_RESTRICT_BY_BUILDING = 'restrictByBuilding'
export const SINGLETON_KIOSK_DESIGNATION = 'SINGLETON_KIOSK'
export const URL_RESET_PASSWORD = 'rstpwd'
export const SUCCESS_LOGIN_BOOT_ACTION_UNLOCK_KIOSK = 'SUCCESS_LOGIN_BOOT_ACTION_UNLOCK_KIOSK'
export const DEFAULT_KIOSK_SNACK_MESSAGE_AUTO_HIDE_MILLIS_SUCCESS = 5000
export const KIOSK_SETTINGS_CATEGORY_ATTENDANCE_LOGIC = 'Attendance Logic'
export const KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR = 'Kiosk Behavior'
export const KIOSK_SETTINGS_CATEGORY_SETTINGS = 'Settings'

export const attributesCategories = {
    [ATR_IS_LOCKED]: null,
    [ATR_ATTENDANCE_TYPE_ID]: KIOSK_SETTINGS_CATEGORY_ATTENDANCE_LOGIC,
    [ATR_RESTRICT_BY_BUILDING]: KIOSK_SETTINGS_CATEGORY_ATTENDANCE_LOGIC,
    [ATR_IS_OUT_OF_BUILDING]: KIOSK_SETTINGS_CATEGORY_ATTENDANCE_LOGIC,
    [ATR_CAN_PRINT]: KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    [ATR_ENABLE_EMAIL_SLIP]: KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    [ATR_ENABLE_PRESENT_SLIP]: KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    [ATR_ENABLE_KEYPAD]: KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    [ATR_ACCEPT_KEYBOARD_INPUT]: KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    [ATR_CHECKIN_FLOW]: KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    [ATR_REQUEST_SEND_REPORT]: KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    [ATR_IS_ENABLED]: KIOSK_SETTINGS_CATEGORY_SETTINGS,
}

export const categoryOrder = [
    null,
    KIOSK_SETTINGS_CATEGORY_ATTENDANCE_LOGIC,
    KIOSK_SETTINGS_CATEGORY_KIOSK_BEHAVIOR,
    KIOSK_SETTINGS_CATEGORY_SETTINGS
]

export const attributesOrder = [
    ATR_IS_LOCKED,
    ATR_ATTENDANCE_TYPE_ID,
    ATR_RESTRICT_BY_BUILDING,
    ATR_IS_OUT_OF_BUILDING,
    ATR_CAN_PRINT,
    ATR_ENABLE_EMAIL_SLIP,
    ATR_ENABLE_PRESENT_SLIP,
    ATR_ENABLE_KEYPAD,
    ATR_ACCEPT_KEYBOARD_INPUT,
    ATR_CHECKIN_FLOW,
    ATR_REQUEST_SEND_REPORT,
    ATR_IS_ENABLED
]